import Vue from 'vue'
import App from './App'
import { getVersionFromServer } from './common/js/http_version'; // 替换成你实际的路径
// 引入echarts
import  * as echarts from "echarts"
Vue.prototype.$echarts = echarts

import format from 'string-format'
import '@mdi/font/css/materialdesignicons.css'  //md图标样式

format.extend(String.prototype, {})

import moment from 'moment'
Vue.prototype.$moment = moment;//赋值使用
moment.locale('zh-cn');//需要汉化
Vue.prototype.$bus = new Vue()
/*饿了么组件*/
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)

// 引入vant
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

//导出xlsx
// import XLSX from 'xlsx'
// Vue.prototype.XLSX = XLSX

/*引入管理后台主题样式*/
import './assets/theme/theme-green/index.css'

import './assets/theme/theme-green/alert.css';
import './assets/theme/theme-green/message.css';//原样式有BUG，已作调整
import './assets/theme/theme-green/message-box.css';//原样式有BUG，已作调整
import './assets/theme/theme-green/dialog.css';
import './assets/theme/theme-green/calendar.css';

import 'font-awesome/css/font-awesome.min.css'

// easyui 
import 'vx-easyui/dist/themes/default/easyui.css';
import 'vx-easyui/dist/themes/icon.css';
import 'vx-easyui/dist/themes/vue.css';
import EasyUI from 'vx-easyui';
Vue.use(EasyUI);

// 修改elementui原有样式
import "./styles/elementui.scss"

/*进度条NProgress组件*/
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(NProgress)
NProgress.configure({showSpinner: false});

/*Mock组件*/
// import Mock from './mock'

// Mock.bootstrap();

// import axios from "axios";
// Vue.prototype.axios = axios;
// Vue.prototype.$fileGet = fileGet

/*路由及状态管理*/
import store from './vuex/store'
import Vuex from 'vuex'
import router from "@/router/router"

Vue.use(Vuex)

/*vuetify全局引入*/
import Vuetify from 'vuetify'
import './assets/vuetify.css';
import colors from 'vuetify/es5/util/colors'/*色彩包*/
Vue.use(Vuetify, {
    theme: {
        primary: colors.red.darken1, // #E53935
        secondary: colors.red.lighten4, // #FFCDD2
        accent: colors.indigo.base // #3F51B5
    },
    icons: {
        iconfont: 'mdi', // 默认值
      },
})
//按钮节流
Vue.directive('throttle', {
  bind: (el, binding) => {
    let throttleTime = binding.value; // 节流时间
    if (!throttleTime) {
      // 用户若不设置节流时间，则默认2s
      throttleTime = 2000;
    }
    let cbFun;
    el.addEventListener(
      'click',
      event => {
        if (!cbFun) {
          // 第一次执行
          cbFun = setTimeout(() => {
            cbFun = null;
          }, throttleTime);
        } else {
          event && event.stopImmediatePropagation();
        }
      },
      true
    );
  },
});




new Vue({
    el: '#app',
    template: '<App/>',
    router,
    store,
    components: {App},
    render: h => h(App, {})
}).$mount('#app')

async function checkVersion() {
  try {
    const localVersion = localStorage.getItem('appVersion');
    const serverVersion = await getVersionFromServer();

    if (!localVersion || localVersion !== serverVersion) {
      // 本地没有版本号，或者版本不一致，存储服务器版本号并刷新页面
      localStorage.setItem('appVersion', serverVersion);
      // location.reload(true);
    } else {
      // 版本一致，无需刷新
    }
  } catch (error) {
    console.error('Version check failed', error);
  }
}

// 调用检查版本函数
checkVersion();




// WEBPACK FOOTER //
// ./src/main.js